import swal from "sweetalert";
import { uploadFile } from "../../../services/BusinessFileUploadService";
import formatError from "../../../services/FormatError";

export async function globalFileUploader(files, entity, entityId) {
  console.log(files, entity, entityId);
  let file;
  if (files) {
    if (Array.isArray(files)) {
      file = files[0];
    } else if (files.length !== undefined) {
      file = files[0];
    } else {
      file = files;
    }
  }
  console.log(file);
  if (file) {
    const sizeLimit = 5 * 1024 * 1024; // 20MB
    const fileType = file.type;
    if (file.size > sizeLimit) {
      swal("Error", "Max File Size is 5 MB!", "error", {
        button: "Try Again!",
      });
    } else if (
      fileType === "image/jpeg" ||
      fileType === "image/jpg" ||
      fileType === "image/png" ||
      fileType === "video/mp4" ||
      fileType === "application/pdf" ||
      fileType === "audio/wav"
    ) {
      let payload = new FormData();
      payload.append("file", file);
      payload.append("entity", entity);
      payload.append("entityid", Number(entityId));
      console.log(payload);

      const result = await uploadedFileHandler(payload, file);
      console.log(result);
      return result;
    } else {
      swal(
        "Oops",
        "Please select a valid file. (images jpg, jpeg, png) (video mp4 only) (document pdf only)",
        "error",
        { button: "Try Again!" }
      );
    }
  }
}

const uploadedFileHandler = async (data) => {
  await uploadFile(data)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      formatError(error.response?.data?.error);
    });
};
